import React from "react";
import GamesPage from "./GamesPage";

const App = () => {
  return <GamesPage />;
};

export default App;
